export const STD_DATE_FORMAT = "YYYY-MM-DDTHH:mm:ss";
export const MONTH_DAY_FORMAT = "MMM D";
